/**
 * The address and header rules every Character Studio wrapper shares. Each
 * path segment is encoded, so a slug or ID containing a slash can never
 * address a different organization's row.
 */
export function segment(value: string): string {
  return encodeURIComponent(value);
}

export function orgRoot(orgSlug: string): string {
  return `/v1/orgs/${segment(orgSlug)}`;
}

/** An accepted or archived character: generation, library and history. */
export function characterRoot(orgSlug: string, characterID: string): string {
  return `${orgRoot(orgSlug)}/characters/${segment(characterID)}`;
}

/** Everything before acceptance lives here: authoring, build and review. */
export function draftRoot(orgSlug: string, draftID: string): string {
  return `${orgRoot(orgSlug)}/drafts/${segment(draftID)}`;
}

/** A paid submission names the revision it saw and its one durable intent. */
export function paidHeaders(etag: string, idempotencyKey: string): HeadersInit {
  return {
    "If-Match": etag,
    "Idempotency-Key": idempotencyKey,
  };
}

export function queryString(
  filters: Record<string, string | number | undefined>,
): string {
  const query = new URLSearchParams();
  for (const [key, value] of Object.entries(filters)) {
    if (value !== undefined && value !== "") query.set(key, String(value));
  }
  const encoded = query.toString();
  return encoded === "" ? "" : `?${encoded}`;
}
